import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import MTable from "../../../../components/mtable"
import { formatEnum } from "../../../../utils/strings"
import Title from "../../../../components/Title"
import { api } from "../../../../env"

export default function ManageCompanyQuestionnaires() {
    const { id: companyId } = useParams()
    const navigate = useNavigate()
    const [companyQuestionnaireIds, setCompanyQuestionnaireIds] = useState([])
    const [added, setAdded] = useState([])
    const [removed, setRemoved] = useState([])

    useEffect(() => {
        api.get(`/companies/${companyId}/questionnaires/ids`)
            .then(res => setCompanyQuestionnaireIds(res.data))
    }, [companyId])

    const handleSelection = (selectedItems) => {
        const selectedIds = selectedItems.map(i => i.id)
        setAdded(selectedIds.filter(id => !companyQuestionnaireIds.includes(id)))
        setRemoved(companyQuestionnaireIds.filter(id => !selectedIds.includes(id)))
    }

    const save = () => {
        api.put(`/companies/${companyId}/questionnaires/access`, { added, removed })
            .then(() => navigate(-1))
    }

    const mapper = { columns: [
        {
            label: "Name",
            style: "full",
            value: (item) => item.name
        },
        {
            label: "Questions Count",
            value: (item) => item.questionsCount,
            width: "0.5fr"
        },
        {
            label: "Status",
            value: (item) => item?.status ? formatEnum(item?.status ?? '') : '--'
        }
    ]}

    return (
        <div className="page-xl-centered standard-padding showing">
            <div className="flex space-between center gap-xs v-spacer-m">
                <Title>Manage Questionnaire Access</Title>
                <button className="solid" onClick={save}>Save</button>
            </div>
            <MTable
                path={'questionnaires'}
                queryParams={{ status: 'Published' }}
                mapper={mapper}
                selectable={{
                    onChange: handleSelection,
                    multiple: true,
                    preselected: companyQuestionnaireIds.map(id => ({ id }))
                }}
            />
        </div>
    )
}